<template>
  <Select
    placeholder="Informe o Nome/CPF/CNPJ"
    labelBusca="name"
    ref="buscarCliente"
    inputClass="busca-cliente"
    :label="label"
    :value="client"
    :options="clients"
    :change="change"
    :search="searchCliente"
    :disabled="disabled"
  >
    <template slot="options" slot-scope="props">
      <div class="selected" style="text-transform: uppercase" @click="removeCurrentClients">
        {{ props.data.name }}
        <br />
        CPF/CNPJ {{ props.data.identification }}
      </div>
    </template>
  </Select>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Select from './Select';

export default {
  name: 'SelectClient',
  mixins: [FormatMixin],
  components: {
    Select,
  },
  props: {
    label: {
      type: String,
      default: 'Cliente',
    },
    client: {
      type: [Object, String],
      default: null,
    },
    change: {
      type: Function,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    filters: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      clients: [],
    };
  },
  methods: {
    searchCliente(search, loading) {
      loading(true);
      this.getClient(loading, search, this);
    },
    removeCurrentClients() {
      this.clients = [];
    },
    getClient: _.debounce(async (loading, search, vm) => {
      if (search === '' || search === null) {
        return loading(false);
      }

      const $this = vm;

      const { data } = await $this.$http.post('/person.get-person', {
        search,
        active: true,
        isClient: true,
        maxResults: 10,
        ...(vm.filters?.withIdentification && { withIdentification: true }),
      });

      $this.clients = data.map((client) => ({
        ...client,
        identification: vm.formatCpfCnpj(client.identification),
      }));

      return loading(false);
    }, 350),
  },
};
</script>
